// extracted by mini-css-extract-plugin
export default {"protocols":"protocols-ORFV_","eventTrigger":"eventTrigger-BVZEz","property":"property-L_Jab","scriptName":"scriptName-njsJh","table":"table-d3Zfg"};